import type { Passenger } from '@aviata/booking-data';
import type { Airflow } from '@aviata/platform-types';
import { dateUtils, citizenshipEntity } from 'shared';

export const convertPassengerToPayload = ({
  passenger,
}: {
  passenger: Passenger;
}): Partial<Airflow.Order.Payload.Passenger> => {
  const isCountryWithoutSeries =
    citizenshipEntity.config.countriesWithoutSeries.includes(
      passenger.citizenship,
    );

  return {
    id: passenger.id,
    first_name: passenger.firstName,
    last_name: passenger.lastName,
    gender: passenger.gender as Airflow.Gender,
    dob: dateUtils.dateToAccountsFormat(passenger.dob),
    citizenship: passenger.citizenship,
    ...(passenger.citizenship === citizenshipEntity.config.KAZAKHSTAN_CODE && {
      national_id: passenger.iin,
    }),
    ...(passenger.citizenship === citizenshipEntity.config.AZERBAIJAN_CODE && {
      fin: passenger.fin,
    }),
    document_number: passenger.document.number,
    document_expires_at: passenger.document.expiresAt
      ? dateUtils.dateToAccountsFormat(passenger.document.expiresAt)
      : undefined,
    ...(!isCountryWithoutSeries && {
      document_series: passenger.document.series,
    }),
    document_issued_by: passenger.document.organization,
    document_issued_date: passenger.document.givenAt
      ? dateUtils.dateToAccountsFormat(passenger.document.givenAt)
      : undefined,
  };
};
